$(document).ready(function ($) {
  const bodyEl = $("body");
  if (!bodyEl.hasClass("single-studio")) {
    return;
  }
  const quickMenuNavEl = $(".quick-menu__nav");
  const quickMenuNavItemEl = $(".quick-menu__nav-item");
  const quickMenuContentItemEl = $(".quick-menu__content-item");
  const screenHeight = $(window).height();
  let lastScrollTop = 0;

  /** CODE FOR SINGLE-STUDIO & SINGLE-STUDIO-SUBPAGES GOES HERE **/
  quickMenuNavItemEl.on("click", handleQuickMenuNavClick);
  $(".quick-menu__close-content-item").on("click", handleQuickMenuNavClick);

  if (!bodyEl.hasClass("single-studio-subpage")) {
    /** CODE FOR SINGLE-STUDIO MAIN-PAGE ONLY GOES HERE **/
    // if (isMobileView()) {
    //   // $(".quick-menu__nav-item.menu").hide();
    //   $(window).on("scroll", handleStudioMainPageOnScroll);
    // }
    return;
  }
  /** CODE FOR SINGLE-STUDIO SUBPAGES ONLY (without single-studio MAIN page) GOES HERE **/
  if (!isMobileView()) {
    quickMenuNavEl.removeClass("collapsed");
    $(window).on("scroll", handleOnWindowScroll);
  }

  /** ============================================================ **/
  // FUNCTIONS
  function handleQuickMenuNavClick() {
    const navItemEl = $(this);
    if (navItemEl.hasClass("menu")) {
      quickMenuNavEl.toggleClass("collapsed");
      quickMenuNavItemEl.removeClass("active");
      quickMenuContentItemEl.removeClass("active");
      return;
    }
    const activePopUpNavItemEl = $(".quick-menu__nav-item.active");
    const activePopUpId = activePopUpNavItemEl.length > 0 ? activePopUpNavItemEl.data("quickMenuId") : false;

    quickMenuNavItemEl.removeClass("active");
    quickMenuContentItemEl.removeClass("active");

    const quickMenuId = navItemEl.data("quickMenuId");
    if (activePopUpId && activePopUpId === quickMenuId) {
      return; // only hide popup
    }
    navItemEl.addClass("active");
    $(".quick-menu__content-item[data-quick-menu-id=" + quickMenuId + "]").addClass("active");
  }

  // function handleStudioMainPageOnScroll() {
  //   const currentScroll = $(this).scrollTop();
  //   if (currentScroll > screenHeight / 2 && currentScroll > lastScrollTop) {
  //     $(".quick-menu__nav-item.menu").show();
  //   } else {
  //     $(".quick-menu__nav-item.menu").hide();
  //   }
  //   lastScrollTop = currentScroll;
  // }

  function handleOnWindowScroll() {
    const currentScroll = $(this).scrollTop();
    if (currentScroll > screenHeight / 2 && currentScroll > lastScrollTop) {
      quickMenuNavEl.addClass("collapsed");
    } else if (currentScroll < screenHeight / 2) {
      quickMenuNavEl.removeClass("collapsed");
    }
    lastScrollTop = currentScroll;
  }

  function isMobileView() {
    return window.matchMedia("(max-width: 480px)").matches;
  }
});
